import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.teamNames,"label":_vm.labelValue,"clearable":_vm.clearable ? _vm.clearable : false,"readonly":_vm.readonly,"outlined":""},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }